import React from "react";
import "../styles/main.scss";

const DecksPage = () => {
  return (
    <div className="container page">
      <h2>Decks</h2>
      <p>Hier kannst du deine Decks verwalten oder ein neues erstellen.</p>
    </div>
  );
};

export default DecksPage;
